module.exports = __webpack_public_path__ + "static/img/医嘱与病历_img.5d11e2d9.png";